import React from 'react'
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Grid,
} from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import EventBadges from '../../../../EventBadges'
import { brandColors, neutralColors } from '../../../../../Common/Color/Color'
import { fontLineHeights, fontSizes } from '../../../../../Common/Typography/TypographyStyles'
import { setDateFormat, setTimeFormat } from '../../../../../../utils/dateUtils'
import { Event } from '../../../../../../redux/event/manageEvents/types'
// import GoogleCalendarIcon from '../../../assets/icons/google_calendar.ico'
import GoogleMeetIcon from '../../../../../../assets/icons/google_meet.ico'
import { useAppSelector } from '../../../../../../redux/store'
import { selectTeamMemberInfo } from '../../../../../../redux/teamMember/selector'

interface GeneralInformationTabPanelProps {
  eventDetail: Event
}

const GeneralInformationTabPanel: React.FC<GeneralInformationTabPanelProps> = ({ eventDetail }) => {
  const teamMemberInfo = useAppSelector(selectTeamMemberInfo)

  return (
    <Grid container spacing={2} direction='column'>
      <Grid>
        <Box>
          <Stack direction='row' spacing={2}>
            <EventBadges value={eventDetail.category || ''} badgeType='categoryBadge' />
            <EventBadges value={eventDetail || ''} badgeType='pointsBadge' />
          </Stack>
        </Box>
      </Grid>
      <Grid>
        <Box>
          <Stack direction='row' spacing={2}>
            {eventDetail.postSurveyURL && eventDetail.isCompleted && (
              <Button
                variant='contained'
                href={eventDetail.postSurveyURL}
                target='_blank'
                rel='noopener noreferrer'
              >
                Take a Survey
              </Button>
            )}
            {eventDetail.googleMeetLink && !eventDetail.isCompleted && (
              <IconButton href={eventDetail.googleMeetLink} target='_blank' rel='noopener noreferrer'>
                <img src={GoogleMeetIcon} alt='Google Meet' style={{ width: '24px', height: '24px' }} />
              </IconButton>
            )}
          </Stack>
        </Box>
      </Grid>

      <Grid container spacing={2} direction='column'>
        <Box
          component='div'
          sx={{
            overflow: 'auto',
            width: 'auto',
            height: 100,
            backgroundColor: neutralColors.greyMystic,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: brandColors.purpleTelus,
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
            scrollbarWidth: 'auto',
            msOverflowStyle: 'auto',
          }}
          p={1}
          borderRadius={2}
        >
          <Typography
            sx={{
              fontSize: fontSizes.size14,
              lineHeight: fontLineHeights.ratio9to4,
            }}
          >
            {eventDetail.details}
          </Typography>
        </Box>
        <Box display='flex' alignItems='center'>
          <FormControl variant='outlined' fullWidth>
            <InputLabel htmlFor='venue-input-field'>EVENT VENUE</InputLabel>
            <OutlinedInput
              id='venue-input-field'
              type='text'
              value={eventDetail.venue}
              defaultValue={eventDetail.venue}
              readOnly
              label='EVENT VENUE'
              startAdornment={
                <InputAdornment position='start'>
                  <LocationOnIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
      </Grid>
      <Grid container justifyContent='flex-end'>
        <Box display='flex' flexDirection='column' alignItems='flex-end' sx={{ padding: 2 }}>
          <Typography variant='body1' fontWeight='bold'>
            Created By
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            {teamMemberInfo?.firstName} {teamMemberInfo?.lastName} {teamMemberInfo?.suffix}
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            {`${setDateFormat(eventDetail.createdAt)} ${setTimeFormat(eventDetail.createdAt)}`}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default GeneralInformationTabPanel
